import { notifications } from "@mantine/notifications"
import { useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"
import z from "zod"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"

export enum OperationChainType {
  PRODUCT = "PRODUCT",
  COMPONENT = "COMPONENT",
  MATERIAL = "MATERIAL",
}

export type CreateOpChainDto = {
  name: string
  type: OperationChainType
}

export const createOpChainSchema = z
  .object({
    name: z.string().min(1),
    type: z.nativeEnum(OperationChainType),
  })
  .strict()

export const useCreateOpChainMutation = () =>
  useMutation<string, AxiosError, CreateOpChainDto>({
    mutationFn: async (data) => {
      const res = await httpClient.post("/admin/op-chain", data)
      return res.data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries(["findAllOpChain"])
      notifications.show({
        title: "Success",
        message: "Operation chain created",
        color: "teal",
      })
    },
    onError: (error) => {
      notifications.show({
        title: "Error",
        message: "Failed to create operation chain cause : " + error.message,
        color: "red",
      })
    },
  })
